<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div class="text-center">
        <img class="mx-auto p-8" src="/images/logo-dark.png" alt="" />
        <NAsyncContainer :loading="verifyLoading" :blank="true">
          <div class="text-lg p-1">
            <template v-if="resultOk.success">
              <div class="text-center">
                <span class="m-4 text-base font-bold">{{ $tl('verifyNotice1') }}</span><br/>
                <span class="m-4 text-base font-bold">{{ $tl('verifyNotice2', {name: $tl('globalName')}) }}</span><br/>
              </div>
              <div class="text-center pt-2">
                <span class="m-4 text-base font-bold">{{ $tl('verifyNotice3') }} <RouterLink to="/login">{{ $tl('login') }}</RouterLink></span>
              </div>
              <div class="text-center pt-1">
                <BaseCollaspe :colLabel="$tl('otherDownloads')">
                  <div class="text-center" style="justify-content: center">
                    <div class="xl:w-[360px] py-2 grid grid-cols-1 xl:grid-cols-1 gap-3">
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openIosAppLink">
                        <template #icon><img src="/images/system/ats-ios.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('ios') }}</span>
                      </NButton>
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openAndroidAppLink">
                        <template #icon><img src="/images/system/ats-android.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('android') }}</span>
                      </NButton>
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openWindowsDesktopAppLink">
                        <template #icon><img src="/images/system/desktop.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('windowsDesktop') }}</span>
                      </NButton>
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openMacX86DesktopAppLink">
                        <template #icon><img src="/images/system/mac.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('macX86Desktop') }}</span>
                      </NButton>
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openMacArmDesktopAppLink">
                        <template #icon><img src="/images/system/mac.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('macArmDesktop') }}</span>
                      </NButton>
                      <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openWebLink">
                        <template #icon><img src="/images/system/ats-web.png" class="inline-block w-[20px]" /></template>
                        <span class="pl-2 system-info">{{ $tl('web') }}</span>
                      </NButton>
                    </div>
                  </div>
                </BaseCollaspe>
              </div>
            </template>
            <template v-else>
                <NForm ref="form" :model="model" class="!grid-cols-1">

                  <div class="grid grid-cols-12 gap-1.5 pt-4 ">
                    <div class="col-start-2 col-end-8 text-center ">
                      <NFormItem>
                        <label class="n-username-bolt">{{ mask }}</label>
                      </NFormItem>
                    </div>
                    <div class="col-start-9 col-end-11 text-center">
                      <NTimer :seconds="timer_count" @timeOut="onTimeOut" @onResend="onResendCode"/>
                    </div>
                  </div>

                  <div class="pt-4 text-center">
                    <NInputVCode @afterFinished="afterVCFinish"/>
                  </div>
                  
                  <template v-if="resultNg.errorCode">
                    <div class="pt-4 text-center">
                      <span class="text-red-600 font-bold">{{ t(resultNg.errorCode, PREFIX.ERROR_CODE) }}</span>
                    </div>
                  </template>
                  
                  <div class="pt-4 text-center">
                    <RouterLink to="/register">{{ $tl('back') }}</RouterLink>
                  </div>
                  
                </NForm>
<!--              </template>-->
            </template>
          </div>
          <template #loading>
            <NSpin />
          </template>
        </NAsyncContainer>
      </div>
      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {useExecute, useLanguage, useRouter} from '@front/hooks';
import {codeVerify, emailVerify, resendVerify} from '@front/api/utility';
import {computed, onMounted, reactive, ref} from 'vue';
import {COPYRIGHT, USERNAME_PROVIDER_TYPE} from '@front/constant';
import {NButton} from "@/components";
import {maskUsername} from "@front/utils";

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();
const verifyLoading = ref(false);

//
// const code = computed(() => router.currentRoute.value.params.code);
// const launchScheme = computed(() => router.currentRoute.value.params.launchScheme);
// const fromPc = computed(() => (launchScheme.value ?? 'pc') === 'pc');

const username = computed(() => decodeURIComponent(router.currentRoute.value.params.username));
const type = computed(() => decodeURIComponent(router.currentRoute.value.params.type));
const isMail = computed(() => type.value === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD);
const mask = computed(() => isMail.value ? username.value : (maskUsername(username.value, 3)));


const code = ref(undefined);
const intervalId = ref(undefined);
const isDev = import.meta.env.isDev;
const timer_count = ref(isDev ? 5 : 60);
const model = reactive({ username: '', password: '', code: '' });

const resultOk = reactive({
  success: false,
  agent: null,
});
const resultNg = reactive({
  success: false,
  errorCode: null,
  message: null,
});

const downloadLinks = reactive({});

const query = router.currentRoute.value.query;
const a = computed(() => query?.a ?? null);

const { loading, execute } = useExecute({
  execute: async () => {
    try {
      verifyLoading.value = true;
      const r = await codeVerify({ code: code.value , username: username.value});
      
      resultOk.success = r.success;
      // 老黄说怕影响其他调用，目前只能这么改
      // resultOk.agent = r.data.message;
      resultOk.agent = r.data.agent;
      downloadLinks.iosAppLink = r.data.iosAppLink;
      downloadLinks.androidAppLink = r.data.androidAppLink;
      downloadLinks.windowsDesktopAppLink = r.data.windowsDesktopAppLink;
      downloadLinks.macX86DesktopAppLink = r.data.macX86DesktopAppLink;
      downloadLinks.macArmDesktopAppLink = r.data.macArmDesktopAppLink;
      downloadLinks.webLink = r.data.webLink;
      
      if (resultOk.success) {
        onFbCompleteRegistration();
      }

      const launchScheme = r.data.launchScheme;
      const fromPc = launchScheme === 'pc';
      
      if (!fromPc) {
        window.location.href = launchScheme;
      }
      
    } catch (err) {
      resultNg.success = err.extra?.success;
      resultNg.errorCode = err.extra?.errorCode;
      resultNg.message = err.extra?.message;
    } finally {
      verifyLoading.value = false;
    }
  },
});


const openIosAppLink = () => window.open(downloadLinks.iosAppLink, '_blank');
const openAndroidAppLink = () => window.open(downloadLinks.androidAppLink, '_blank');
const openWindowsDesktopAppLink = () => window.open(downloadLinks.windowsDesktopAppLink, '_blank');
const openMacX86DesktopAppLink = () => window.open(downloadLinks.macX86DesktopAppLink, '_blank');
const openMacArmDesktopAppLink = () => window.open(downloadLinks.macArmDesktopAppLink, '_blank');
const openWebLink = () => window.open(downloadLinks.webLink, '_blank');


onMounted(() =>{
  startTimer();
})

function onFbCompleteRegistration() {
  window.fbq?.('track', 'CompleteRegistration', {
    content_name: 'registration',
    contents: { channel: 'email', agent: resultOk.agent ?? undefined },
    status: true,
  });
}


async function afterVCFinish(vcode) {
  code.value = vcode;
  await execute();
}

async function onResendCode(){
  const r = await resendVerify({username: username.value});
  if(r.success){
    timer_count.value = isDev ? 5 : 60;
    startTimer();
  } 
}

function onTimeOut(){
}

function startTimer(){
  intervalId.value = setInterval(() => {
    if(timer_count.value > 0){
      timer_count.value = timer_count.value - 1;
    } else {
      // emits('timeOut');
      hadTimeout();
    }
  }, 1000);

}

function hadTimeout(){
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = undefined;
  }
}

</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
.ant-collapse>.ant-collapse-item>.ant-collapse-header{
  justify-content: center;
}
</style>
